export const WEBGATE_SERVICE = 'webgate.service';
export const SERVICE_VERSION = 'service.version';
export const SERVICE_HASH = 'service.hash';
export const POD = 'pod';
export const WEBSITE_ORIGIN_POD_TAG = 'website.origin_pod';
export const HTTP_MODE = 'http.mode';
export const HTTP_HASH = 'http.hash';
export const HTTP_HREF = 'http.href';
export const HTTP_PROTOCOL = 'http.protocol';
export const HTTP_ORIGIN = 'http.origin';
export const HTTP_HOST = 'http.host';
export const HTTP_HOSTNAME = 'http.hostname';
export const HTTP_PORT = 'http.port';
export const HTTP_PATHNAME = 'http.pathname';
export const HTTP_SEARCH = 'http.search';
export const HTTP_RES_REDIRECTED = 'http.res.redirected';
export const HTTP_RES_TYPE = 'http.res.type';
export const HTTP_RES_URL = 'http.res.url';
export const HTTP_RES_OK = 'http.res.ok';
export const HTTP_STATUS_CODE_GROUP = 'http.status_code_group';
export const OPERATION_KIND = 'operation.kind';
export const NAVIGATOR_ONLINE = 'navigator.onLine';
export const NAVIGATOR_USER_AGENT = 'navigator.user_agent';
export const NAVIGATOR_WEBDRIVER = 'navigator.webdriver';
//# sourceMappingURL=tags.js.map